import { buildUuidUtil } from './uuid-helpers';
import type { BrandedUuid } from './uuid-helpers';

export type UserId = BrandedUuid<'UserId'>;
export const UserId = buildUuidUtil('UserId');

export type OrganizationId = BrandedUuid<'OrganizationId'>;
export const OrganizationId = buildUuidUtil('OrganizationId');

export type EmployeeId = BrandedUuid<'EmployeeId'>;
export const EmployeeId = buildUuidUtil('EmployeeId');

export type CandidateId = BrandedUuid<'CandidateId'>;
export const CandidateId = buildUuidUtil('CandidateId');

export type ApplicationId = BrandedUuid<'ApplicationId'>;
export const ApplicationId = buildUuidUtil('ApplicationId');

export type ApplicationStageId = BrandedUuid<'ApplicationStageId'>;
export const ApplicationStageId = buildUuidUtil('ApplicationStageId');

export type JobId = BrandedUuid<'JobId'>;
export const JobId = buildUuidUtil('JobId');
